import { FormState } from '@vtex/admin-ui-form'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import { LIMITS } from 'shared'
import { Item } from 'typings'
import { MultiSelect } from '../../../MultiSelect'
import { searchItems } from '../../../utils'
import { ItemRenderer } from './ItemRenderer'
import { messages } from './messages'

type Props = {
  name: string
  state: FormState
  shippingOptions: Item[] | undefined
  loading: boolean
}

export function ShippingMethodsSelector(props: Props) {
  const { name, state, shippingOptions, loading } = props
  const { formatMessage: i18n } = useIntl()

  const [searchTerm, setSearchTerm] = useState('')

  const options = useMemo(
    () => searchItems(shippingOptions, searchTerm),
    [searchTerm, shippingOptions]
  )

  return (
    <MultiSelect
      name={name}
      options={options ?? []}
      label={i18n(messages.input)}
      onSearch={setSearchTerm}
      loadingOptions={loading}
      maxEntries={LIMITS.MAX_SHIPPING_METHODS}
      state={state}
      renderOption={(item) => <ItemRenderer item={item} />}
      renderTag={(item) => <ItemRenderer item={item} maxWidth={200} />}
    />
  )
}
